import App from './app';

window.addEventListener('load', () => {	
	new App();
});
